import request from "@/utils/request";

// 领取优惠券
export const couponPublic = data => {
  return request({
    url: "/venue/Fee/couponPublic",
    method: "POST",
    data
  });
};
